import axios from "axios"


function getStaticData() {
    return axios.get(`/api/v1/static-data`)

}

// Public, read before any account by every login screen (`refreshLoginStaticData`): it carries the off
// switch of the OTA applied at launch (`apply_update_on_launch`, `featureFlags/launchUpdateFF`) to
// logged-out devices. `silentNetworkError`: a device offline on the login screen never gets a
// « Problème de connexion réseau » for a read nobody asked for — `refreshLoginStaticData` swallows its
// failure. The other interceptors (timing, Bugsnag) still run.
function getLoginStaticData() {
    return axios.get(`/api/v1/static-data/login`, { silentNetworkError: true })
}

function getStaticDataTrial() {
    return axios.get(`/api/v1/static-data/register`)

}


export const staticDataService = {

    getStaticData,
    getStaticDataTrial,
    getLoginStaticData,
}